import { SagaIterator } from 'redux-saga';
import { call, takeEvery } from 'redux-saga/effects';

import { OpenGeocodingConfigDialog } from '~src/bootstrap/redux/actions/AppActionTypes';
import { getDatasourceDetailInfo } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { OpenGeocodingConfigDialogAction } from '../actions/OpenGeocodingConfigDialogAction';
import { fetchGeocodingConfigAndLaunchDialog } from '../components/configDialog/GeocodingConfigDialog';

export function* handleOpenGeocodingConfigDialogAction(action: OpenGeocodingConfigDialogAction) {
    const datasourceDetailInfo = yield call(getDatasourceDetailInfo, action.geocodingTaskInfo.unifiedDataConnectionId);
    yield call(fetchGeocodingConfigAndLaunchDialog, action.geocodingTaskInfo, datasourceDetailInfo);
}

export function* rootGeocodingTaskActionSaga(): SagaIterator {
    yield takeEvery(OpenGeocodingConfigDialog, handleOpenGeocodingConfigDialogAction);
}
